import type { ReactNode } from 'react';
import { ThemeProvider, createTheme, type Theme } from '@mui/material/styles';

// Module-level so ThemeProvider sees one function and only rebuilds when the outer theme changes.
const withBrandPurpleButtons = (outerTheme: Theme) =>
    createTheme(outerTheme, {
        components: {
            MuiButton: {
                defaultProps: {
                    color: 'brandPurple',
                },
            },
        },
    });

interface RedesignButtonThemeProps {
    /** Off renders the children under the outer theme unchanged, for a flow behind the redesign gate. */
    readonly enabled: boolean;
    readonly children: ReactNode;
}

/**
 * Makes the redesign's lighter brand purple the default colour of every button inside it, so the V1
 * setup flows get it on the wizard's own Next and Complete, on step footers and in their dialogs,
 * without each one naming it. A button that sets its own colour — the secondary Back, an onyx pill —
 * keeps it.
 */
export default function RedesignButtonTheme({ enabled, children }: Readonly<RedesignButtonThemeProps>) {
    if (!enabled) {
        return children;
    }
    return <ThemeProvider theme={withBrandPurpleButtons}>{children}</ThemeProvider>;
}
